import { Button, DiscountChip, Spinner } from "@silversea-ssc/ui-components-react"
import React, { ReactElement } from "react"
import clsx from "clsx"
import { PriceInfoStatus } from "../../../app-core/_common/get-price-info"
import styles from "./PriceBox.module.scss"

interface PriceBoxProps {
    topLabel: string
    amount: string
    originalAmount?: string
    toggleButtonLabel: string | ReactElement
    buttonDataContentPiece: string
    onToggleOpen: () => void
    className?: string
    status: PriceInfoStatus
}

const PriceBox: React.FC<React.PropsWithChildren<PriceBoxProps>> = ({
    topLabel,
    amount,
    originalAmount,
    onToggleOpen,
    toggleButtonLabel,
    buttonDataContentPiece,
    className,
    status,
}) => {
    const amountOrSpinner = status == "loading" ? <Spinner color="neutral10" size="small" /> : amount || ""

    return (
        <>
            <button
                onClick={onToggleOpen}
                className={clsx(className, styles.priceBox)}
                data-content-piece={buttonDataContentPiece}
            >
                <div className={styles.label}>{topLabel}</div>
                <div className={styles.title} data-test-id="price-box-amount">
                    {originalAmount && (
                        <React.Fragment>
                            <DiscountChip lineThrough background={"white"} className={styles.originalAmount}>
                                {originalAmount}
                            </DiscountChip>{" "}
                        </React.Fragment>
                    )}
                    {amountOrSpinner}
                </div>

                <div>
                    <Button
                        renderAs="div"
                        variant="inline-text"
                        className={clsx("cy-price-details-btn", styles.toggleButton)}
                        dataContentPiece="price_details"
                    >
                        {toggleButtonLabel}
                    </Button>
                </div>
            </button>
        </>
    )
}

export default PriceBox
